import defaultRatingsBoards from 'rlink-regions/ratingsBoards';

export const SKU_GROUPS = {
  tr: ['TR'],
  nas: ['RU', 'BY', 'UA', 'AM', 'AZ', 'GE', 'KZ', 'KG', 'MD', 'TJ', 'TM', 'UZ'],
  sea: ['SG', 'MY', 'PH', 'ID', 'BN'],
  msa: ['TH', 'LA', 'KH', 'VN', 'MM', 'IN'],
  sa: ['BR', 'CO', 'AR', 'PE', 'VE', 'CL', 'EC', 'BO', 'PY', 'UY', 'GY', 'SR', 'GF', 'FK'],
  ea: ['CN', 'TW', 'HK', 'JP'],
  ko: ['KR'],
  // only used by scalefast
  us: ['US', 'CA'],
  uk: ['GB'],
  reu: ['AT', 'AU', 'BE', 'BG', 'CY', 'HR', 'DK', 'ES', 'EE', 'FI', 'FR', 'GR', 'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL', 'PL', 'PT', 'CZ', 'RO', 'EN', 'SK', 'SI', 'SE', 'GP', 'GF', 'MQ', 'RE', 'MF'],
  de: ['DE'],
};

export const REGION_RESTRICTIONS = {
  fr: ['FR'],
};

export const RATINGS_BOARDS = defaultRatingsBoards;



// WEBPACK FOOTER //
// ./apps/www.dawnofwar.com/src/region-config.js